export default "__VITE_ASSET__$dS_FKZW__"